// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import './SuccessHeader.sass';

export const SuccessHeader = ({ctaText, cta, qaId, subText = ''}) => (
  <div className="card-success__header">
    <img
      src="/assets/images/event/success/highfive.gif"
      className="card-success__header__image"
      alt="highfive"
    />
    <Typography variant="header4">Congratulations!</Typography>
    <Typography variant="paragraph2" color="pebble" className="success-header__subtext">
      {subText}
    </Typography>
    <Link href={cta} as="primary" data-qa-id={qaId}>
      {ctaText}
    </Link>
  </div>
);
